import {
  createClientAnalyticsEvent,
  createPageViewParams,
  sanitizeClientScreen,
} from "@dutyon/apis";

const isBrowser = typeof window !== "undefined";

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export const initGA = (measurementId: string): void => {
  if (!isBrowser) return;
  if (!measurementId) {
    console.warn("[분석 로깅] 측정 ID가 없어 기존 GA 수집을 시작하지 않았습니다.");
    return;
  }

  const scriptId = "google-analytics-script";
  if (!document.getElementById(scriptId)) {
    const script = document.createElement("script");
    script.id = scriptId;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);
  }

  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = (...args: unknown[]) => {
      window.dataLayer?.push(args);
    };
  }

  window.gtag("js", new Date());
  window.gtag("config", measurementId, {
    ...createPageViewParams(window.location.pathname, window.location.origin, "DutyOn"),
    send_page_view: false,
  });

  console.info("[분석 로깅] 기존 GA 수집을 시작했습니다.");
};

export interface EventParams {
  category?: string;
  label?: string;
  value?: number;
  [key: string]: string | number | boolean | undefined;
}

export const trackEvent = (eventName: string, params?: EventParams): void => {
  if (!isBrowser) return;
  const event = createClientAnalyticsEvent(eventName, params);
  if (event && window.gtag) {
    window.gtag("event", event.name, {
      ...event.params,
      ...createPageViewParams(window.location.pathname, window.location.origin, "DutyOn"),
    });
  }
};

export const trackPageView = (path: string, _title?: string): void => {
  if (!isBrowser) return;
  const safePath = sanitizeClientScreen(path);
  const handledByRegisteredProvider = !window.dispatchEvent(
    new CustomEvent("dutyon:page-view", {
      cancelable: true,
      detail: { path: safePath },
    }),
  );
  if (!handledByRegisteredProvider && window.gtag) {
    window.gtag("event", "page_view", {
      ...createPageViewParams(safePath, window.location.origin, "DutyOn"),
    });
  }
};

export interface DutyAutoGenerationEventParams {
  dutyCount: number;
  mode?: "gpu" | "cpu" | "manual";
  source?: "dashboard" | "app";
}

export const trackDutyAutoGeneration = (params: DutyAutoGenerationEventParams): void => {
  if (!isBrowser) return;
  trackEvent("duty_auto_generated", {
    duty_count: params.dutyCount,
    mode: params.mode,
    source: params.source,
  });
};
